import { DataFetcher } from 'data-fetcher/data-fetcher';
import gumboDatasource from '../../datasources/gumbo';
import { defaults as defaultsDatasource } from '../../datasources/defaults';

const API_DATASOURCE = 'gumbo';
const DIFFPATCH = '/diffPatch';
const EMPTY = '';

class DataFetchService {
    constructor (_opts) {
        this.opts = _opts;
        const { env, timecode, startTimecode, endTimecode, site, language, pushUpdateId, secondHelping, gamePk } = this.opts;
        this.params = {
            gamePk,
            startTimecode,
            endTimecode: timecode,
            site,
            language,
            pushUpdateId,
            secondHelping
        };
        this.dataFetcher = new DataFetcher();
        const datasourceManager = this.datasourceManager = this.dataFetcher.datasourceManager;
        datasourceManager.add({
            defaults: defaultsDatasource,
            [API_DATASOURCE]: gumboDatasource
        });
        datasourceManager.setEnv(env);
    }

    /**
     * Function fetch
     * @param dataSourceName {string}
     * @param refresh {boolean}
     *
     * @return {object} Promise object from dataFetcher
     *
     * fetch from given datasource with params
     */
    fetch (dataSourceName, refresh = false) {
        return this.dataFetcher.get({
            dataSourceName,
            refresh,
            params: this.params
        });
    }

    /**
     * Function fetchAPIData
     * @return {object} Promise object from dataFetcher
     *
     * setup params & hit API datasource
     */
    fetchAPIData () {
        this.buildParamStrings();
        return this.fetch(API_DATASOURCE, true);
    }

    /**
     * Function buildParamStrings
     *
     * stringify params to be used in fetch function
     */
    buildParamStrings () {
        const diffPatch = this.params.secondHelping;
        this.params.differ = diffPatch ? DIFFPATCH : EMPTY;
        let tcString = EMPTY;
        if (diffPatch) {
            tcString += this.params.startTimecode ? '&startTimecode=' + this.params.startTimecode : '';
            tcString += this.params.endTimecode ? '&endTimecode=' + this.params.endTimecode : '';
        } else if (this.params.endTimecode) {
            const paramString = '&timecode=' + this.params.endTimecode;
            tcString += paramString;
        }
        this.params.timecode = tcString;

        this.params.pushUpdate = this.params.pushUpdateId ? `&pushUpdateId=${this.params.pushUpdateId}` : '';
    };

    /**
     * Function updateParams
     * @param newParams {object}
     * @param refresh {boolean}
     *
     * @return {object} Promise object from dataFetcher
     *
     * fetch from given datasource with params
     */
    updateParams (newParams) {
        const updatedParams = { ...this.params, ...newParams };
        this.params = updatedParams;
    }

    updateConfig (newConfig, reset = true) {
        this.opts = reset ? newConfig : { ...this.opts, ...newConfig };
        const { timecode, startTimecode, endTimecode, site, language, pushUpdateId, secondHelping, gamePk } = this.opts;
        this.params = {
            gamePk,
            startTimecode,
            endTimecode: timecode,
            site,
            language,
            pushUpdateId,
            secondHelping
        };
    }
};

export default DataFetchService;
